/**
 * 金额格式化（后端已 fen2yuan，前端直接展示元）
 */

export function fmtMoney(v) {
	if (v == null || v === '') return '0.00';
	return Number(v).toLocaleString(undefined, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
}

export function fmtAmount(v) {
	if (v == null || v === '') return '0.00';
	const num = Number(v);
	if (Number.isNaN(num)) return '0.00';
	const prefix = num > 0 ? '+' : '';
	return prefix + num.toLocaleString(undefined, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
}
